"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressTracker = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ProgressTrackerStep_1 = require("./ProgressTrackerStep");
var ProgressTrackerDivider_1 = require("./ProgressTrackerDivider");
var ProgressTracker = function (_a) {
    var children = _a.children, className = _a.className, completed = _a.completed, _b = _a.currentIndex, currentIndex = _b === void 0 ? 0 : _b, rest = __rest(_a, ["children", "className", "completed", "currentIndex"]);
    var renderSteps = function () {
        return react_1.default.Children.map(children, function (child, index) {
            var childProps = {
                key: index + "-step",
                stepNumber: index + 1,
                active: child.props.active,
                completed: child.props.completed,
                editing: child.props.editing,
            };
            var isIndexed = currentIndex !== false;
            var isActive = index === currentIndex;
            var isBeforeActive = index < currentIndex;
            var flowPreviouslyCompleted = completed;
            if (isIndexed) {
                if (flowPreviouslyCompleted) {
                    // If currentIndex is used and this is the current step
                    if (isActive)
                        childProps.editing = true;
                    // If currentIndex is used and this step is not the active step and this flow has been previously completed
                    if (!isActive)
                        childProps.completed = true;
                }
                if (!flowPreviouslyCompleted) {
                    // If currentIndex is used and this is the current step
                    if (isActive)
                        childProps.active = true;
                    // If currentIndex is used and this step is before the current step
                    if (isBeforeActive)
                        childProps.completed = true;
                }
            }
            return [
                index > 0 && (react_1.default.createElement(ProgressTrackerDivider_1.ProgressTrackerDivider, { key: index + "-divider" })),
                react_1.default.cloneElement(child, childProps),
            ];
        });
    };
    var ProgressTrackerClasses = classnames_1.default('ProgressTracker', className, {
        'ProgressTracker--completed': completed,
    });
    return (react_1.default.createElement("div", __assign({ className: ProgressTrackerClasses }, rest), renderSteps()));
};
exports.ProgressTracker = ProgressTracker;
exports.ProgressTracker.Step = ProgressTrackerStep_1.ProgressTrackerStep;
exports.ProgressTracker.Divider = ProgressTrackerDivider_1.ProgressTrackerDivider;
//# sourceMappingURL=ProgressTracker.js.map